import { FeatureIconItem } from "./FeatureIconItem";
import { FeatureImageItem } from "./FeatureImageItem";
import { ListIconItem } from "./ListIconItem";
import { PlainItem } from "./PlainItem";
import { SubMenuItemsType } from "@/types/menu";

const componentMap: Record<string, React.FC<{ items: SubMenuItemsType }>> = {
  "Feature Icon Item": FeatureIconItem,
  "Feature Image Item": FeatureImageItem,
  "List Icon Item": ListIconItem,
  "Plain Item": PlainItem,
};

export const SubMenuItems = ({ items }: { items: SubMenuItemsType }) => {
  const Component = componentMap[items.displayStyle ?? ""] ?? PlainItem;
  if (!items?.items || items.items.length === 0) return null;

  return <Component items={items} />;
};

SubMenuItems.displayName = 'NavSubMenuItems'; 